// Data/Forms/Inventory/Adjustments/forms.js
const forms = [
    {
        name: "Inventory",
        options: [
            {
                name: "Batch",
                type: "select",
                form: {
                    name: "inventory",
                    allowClear: true,
                    showSearch: true,
                    filterOption: false,
                    placeholder: "Search batch or product",
                    api: "get-all-inventories",
                    options: null,
                    value: null,
                    required: true,
                }
            }
        ]
    },
    {
        name: "Inventory Details",
        options: [
            {
                name: "Product",
                type: "input",
                form: {
                    type: "text",
                    name: "product_name",
                    placeholder: "Product",
                    value: "",
                    disabled: true,
                    required: false,
                }
            },
            {
                name: "Current Stock",
                type: "input",
                form: {
                    type: "number",
                    name: "current_stock",
                    placeholder: "Current Stock",
                    value: "",
                    disabled: true,
                    required: false,
                }
            },
            {
                name: "Purchase Price",
                type: "input",
                form: {
                    type: "number",
                    name: "purchase_price",
                    placeholder: "Purchase Price",
                    value: "",
                    disabled: true,
                    required: false,
                }
            }
        ]
    },
    {
        name: "Adjustment",
        options: [
            {
                name: "Adjustment Type",
                type: "select",
                form: {
                    name: "type",
                    allowClear: false,
                    placeholder: "Select Type",
                    options: [
                        { value: "damage", label: "Damage" },
                        { value: "wastage", label: "Wastage" },
                        { value: "expired", label: "Expired" },
                        { value: "return", label: "Return" },
                    ],
                    value: null,
                    required: true,
                }
            },
            {
                name: "Quantity",
                type: "input",
                form: {
                    type: "number",
                    name: "quantity",
                    placeholder: "Quantity to adjust",
                    value: "",
                    required: true,
                }
            },
            {
                name: "Reason",
                type: "input",
                form: {
                    type: "text",
                    name: "reason",
                    placeholder: "Reason for adjustment",
                    value: "",
                    required: true,
                }
            },
            {
                name: "Notes",
                type: "input",
                form: {
                    type: "text",
                    name: "note",
                    placeholder: "Additional notes",
                    value: "",
                    required: false,
                }
            },
            {
                name: "Date",
                type: "date",
                form: {
                    name: "date",
                    placeholder: "Adjustment date",
                    value: "",
                    required: true,
                }
            },
            {
                name: "Image",
                type: "upload",
                form: {
                    name: "image",
                    value: "",
                    required: false,
                }
            }
        ]
    }
];

export default forms;